<template>
  <div :id="id" class="w-max">
    <div class="cursor-pointer" @click="handleIconClick()">
      <slot name="icon">
        <aha-icon
          name="kebab-menu"
          width="18"
          height="18"
          viewBox="0 0 14 14"
        />
      </slot>
    </div>
    <aha-context-menu
      ref="context-menu"
      :target="id"
      :x="targetX"
      :y="targetY"
      forceMenuPosition
    >
      <aha-context-menu-header>
        <slot name="header" />
      </aha-context-menu-header>

      <slot name="items" />
    </aha-context-menu>
  </div>
</template>
context
<script>
import AhaContextMenu from './context-menu/ContextMenu.vue'
import AhaContextMenuHeader from './context-menu/ContextMenuHeader.vue'

export default {
  name: 'ThumbnailContextMenu',
  components: {
    AhaContextMenu,
    AhaContextMenuHeader,
  },
  props: {
    id: {
      type: String,
      default() {
        return Math.random().toString().substring(7)
      },
    },
  },
  data() {
    return {
      targetX: null,
      targetY: null,
    }
  },
  methods: {
    handleIconClick() {
      const icon = document.getElementById(this.id)
      this.targetX = 0
      this.targetY = icon.offsetTop
      this.$refs['context-menu'].show()
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
